/* eslint-disable camelcase -- FIXME: automatically added for existing issue */
import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const validateBenefitPlanConfig = ({ planId: plan_id }) =>
  call(websocketFetch, 'validate_benefit_plan_config', { plan_id });
